export default {
  data: () => ({
    __refreshTimeout: null
  }),

  methods: {
    lazyQuery (callback) {
      // если есть уже задача, то отменить
      if (this.__refreshTimeout) {
        clearTimeout(this.__refreshTimeout)
      }
      this.__refreshTimeout = setTimeout(() => {
        callback()
        this.__refreshTimeout = null
      }, 500)
    }
  }
}
